import { type AddToCartActionStatus } from "@/app/actions/cart";

export const ADD_TO_CART_ERROR_MESSAGES: Record<AddToCartActionStatus, string> =
	{
		refused: "We couldn't add this item to your cart. Please try again.",
		"cart-locked":
			"Your cart can't be changed while checkout is in progress.",
		"cart-submitted":
			"This cart has already been submitted. Please refresh the page to start a new cart.",
		"network-error":
			"Something went wrong on our end. Please try again in a moment.",
		"out-of-stock": "Sorry, this item is out of stock.",
		"session-expired":
			"Your session has expired. Please refresh the page and try again.",
		"purchase-restricted":
			"This item can't be added to your cart due to purchase restrictions.",
		unknown: "We couldn't add this item to your cart. Please try again."
	};

export function getAddToCartErrorMessage(
	status: AddToCartActionStatus,
	message?: string
): string {
	if (status === "refused" && message) return message;
	return ADD_TO_CART_ERROR_MESSAGES[status];
}
